import { FC } from 'react';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TextField from 'components/TextField';

const GeneralSettingsEditFormOpenGraph: FC = () => (
  <Section id="openGraph" title="Open Graph ir Structured Data nustatymai">
    <Stack spacing={4}>
      <TextField fullWidth name="facebookAppId" label="Facebook App ID" />
      <TextField
        fullWidth
        name="schemaProviderDetails.name"
        label="Pavadinimas"
      />

      <TextField
        fullWidth
        name="schemaProviderDetails.image"
        label="Nuotrauka (URL)"
      />

      <TextField
        fullWidth
        name="schemaProviderDetails.pricerange"
        label="Kainų intervalas"
      />

      <TextField
        fullWidth
        name="schemaProviderDetails.phone"
        label="Telefonas"
      />

      <TextField
        fullWidth
        name="schemaProviderDetails.address"
        label="Adresas (gatvė)"
      />

      <TextField fullWidth name="schemaProviderDetails.city" label="Miestas" />

      <TextField
        fullWidth
        name="schemaProviderDetails.country"
        label="Šalies Kodas"
      />

      <TextField
        fullWidth
        name="schemaProviderDetails.postcode"
        label="Pašto kodas"
      />

      <TextField
        fullWidth
        name="schemaProviderDetails.logo"
        label="Leidėjo logo (URL)"
      />
    </Stack>
  </Section>
);

export default GeneralSettingsEditFormOpenGraph;
